<template>
  <div class="head-menu" v-if="siblingRoutes && siblingRoutes.length">
    <div class="head-menu-flex">
      <div
        :class="$store.state.currentFirstLevelMenu && $store.state.currentFirstLevelMenu.path === item.path ? 'menu-item is-active' : 'menu-item'"
        v-for="(item, index) in siblingRoutes" :key="index" @click="navigateToRoute(item)">{{ item.meta.title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeadMenu',
  data() {
    return {
      siblingRoutes: [],
      userInfo: this.$store.getters['user/userInfo']
    }
  },

  computed: {
    avatarText() {
      return this.getAvatarText(this.userInfo.name)
    }
  },

  mounted() {
    console.log(this.$store.state.currentFirstLevelMenu, 'this.$store.state.currentFirstLevelMenu')
    // 组件挂载后立即更新当前一级菜单
    this.updateCurrentFirstLevelMenu();
  },

  watch: {
    // 监听路由对象中的变化
    '$route': {
      handler: function (to) {
        this.siblingRoutes = this.siblingFirstRoutes()
        // 路由变化时，更新当前选中的一级菜单
        this.updateCurrentFirstLevelMenu()
      },
      // 如果需要在路由变化时立即响应，可以设置immediate为true
      immediate: true
    }
  },
  methods: {
    // 获取所有一级菜单（含元信息）
    siblingFirstRoutes() {
      const routes = this.$router.options.adminRoutes;
      // 过滤掉隐藏的路由
      return routes.filter(route => {
        return !route.meta || !route.meta.hidden;
      });
    },

    getAvatarText(name) {
      if (!name) return '';

      // Remove any whitespace
      const cleanName = name.trim();

      // For two-character names, return both characters
      if (cleanName.length === 2) {
        return cleanName;
      }

      // For names with 3 or more characters, return the last two
      if (cleanName.length >= 3) {
        return cleanName.slice(-2);
      }

      // For single character names, just return that character
      return cleanName;
    },

    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout();
      }
      if (command === 'home') {
        this.$router.push('/chat/index')
      }
    },

    handleLogout() {
      // 调用退出登录的方法，具体实现可能需要调用 store action
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    },


    // 导航到选中的路由
    navigateToRoute(item) {
      // 设置当前选中的一级菜单
      this.$store.commit('SET_CURRENT_FIRST_LEVEL_MENU', item);

      if (item.redirect) {
        this.$router.push(item.redirect);
      } else {
        this.$router.push(item.path);
      }
    },

    // 根据当前路由更新选中的一级菜单
    updateCurrentFirstLevelMenu() {
      const currentPath = this.$route.path.trim();
      // 使用 store 中的 action 查找并设置一级菜单
      this.$store.dispatch('findAndSetFirstLevelMenu', {
        path: currentPath,
        router: this.$router
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.head-menu {
  background: #F5F6F9;
  width: 100%;
  position: sticky;
  top: 0px;
  //padding: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  .head-menu-flex {
    display: flex;
    align-items: center;
    flex: 1;
    width: 0;
    gap: 50px;
    padding: 20px 20px 0px 10px;
  }

  .menu-item {
    font-size: 16px;
    cursor: pointer;
    color: #3F3E62
  }

  .is-active {
    color: #000;
    border-radius: 37px;
    font-weight: 500;
    font-size: 17px;
  }
}
</style>
